import _ from 'lodash';

export const appendOrReplaceInArray = <O>(
  input: O[],
  index: number,
  obj: O,
  def: O,
) => {
  let arr = [...input];
  if (index < arr.length) {
    arr[index] = obj;
    return arr;
  }

  const numFill = index - arr.length;
  if (numFill > 0) {
    arr = arr.concat(Array.from(Array(numFill)).map(__ => {
      if (!_.isNil(def) && typeof def === 'object') {
        if (Array.isArray(def)) return [...def] as typeof def;
        return {...def};
      };
      return def;
    }));
  }
  arr.push(obj);
  return arr;
};